<template>
	<reportFormWrap
		ref="reportFormWrap"
		:reportid="reportid"
		:orderMenu="orderMenu"
		:settingCols="settingCols"
		:reportName="reportName"
		:getFiltersParams="getFiltersParams"
		:getCustomThroughParams="getCustomThroughParams"
		@clearSearchClick='clearSearchClick'
		:reportFormUrl="reportFormUrl">
		<FiltersBox slot="filters" ref="filters" @inputEnter='inputEnter'></FiltersBox>
	</reportFormWrap>
</template>

<script>
import { cols } from '@/js/reportform/goodMarketNew.js'
import { orderMenu } from '@/js/reportform/reportformCommon.js'
import reportFormWrap from '@/components/reportform/common/ReportFormWrapNew.vue'
import FiltersBox from '@/components/reportform/goodMarketNew/FiltersBox.vue'
export default {
	name: 'goodMarketNew',
	components: {
		reportFormWrap,
		FiltersBox
	},
	data () {
		return {
			reportid: 'REPORT_SPXS_000001',
			settingCols: cols,
			reportFormUrl: `${this.$fxBaseApi.urlReport}/report/getProductSaleReport`,
			orderMenu: orderMenu,
			reportName: 'goodMarketNew'
		}
	},
	mounted () {
		this.$refs.reportFormWrap.initReportForm()
	},
	methods: {
		clearSearchClick () {
			this.$refs.filters.clearSearch()
		},
		inputEnter () {
			return this.$refs.reportFormWrap.searchHandler()
		},
		getFiltersParams () {
			return this.$refs.filters.getFiltersParams()
		},
		getCustomThroughParams () {
			return this.$refs.filters.getFiltersDate()
		}
	}
}
</script>
